import styles from './ContentBox.module.css';

const ContentBox = ({ title, text, image, contentWidth = '100%', leftSide = false }) => {
    const contentBoxClass = `${styles.contentBox} ${leftSide ? styles.leftSide : styles.rightSide}`;
    
    return (
        <div className={contentBoxClass}>
            <div 
                className={styles.content}
                style={{ width: contentWidth }}
            >
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.description}>{text}</p>
            </div>
            {image && (
                <div className={styles.imageContainer}>     
                    <img src={image} alt={title} className={styles.image} />
                </div>
            )}
        </div>
    );
};

export default ContentBox;
